import { HttpMethod } from "../http-request";
import { ApiEndpointSpecification } from "./types";
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_SERVICE_PARTNER_INFO_DETAILS } from "./url-constants";

type ServicePartnerInfoListEndpointSpecifications = ApiEndpointSpecification;
export const ServicePartnerInfoListEndpointSpecification: ServicePartnerInfoListEndpointSpecifications = {
    url: GET_SERVICE_PARTNER_INFO_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'ServicePartnerInfoListRequestParams',
    requestBodySchemaName: 'ServicePartnerInfoListRequestBody',
    okResponseSchemaName: 'ServicePartnerInfoListOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
}

export const invokeServicePartnerInfoListDetails = Helpers.makeApiRequestFn<
    Types.ServicePartnerInfoListRequestParams,
    Types.ServicePartnerInfoListRequestBody,
    Types.ServicePartnerInfoListOkResponse>(ServicePartnerInfoListEndpointSpecification)